export const TEXTS = {
  banner_title: 'THE BRAND',
  banner_subtitle: 'OF LUXERIOUS <span>FASHION</span>',
  featured_title: 'Featured Items',
  featured_subtitle: 'Shop for items based on what we featured in this week',
  browse_all: 'Browse All Product',
  review_text: '"Vestibulum quis porttitor dui! Quisque viverra nunc mi, a pulvinar purus condimentum"',
  subscribe_title: 'SUBSCRIBE',
  subscribe_subtitle: 'FOR OUR NEWLETTER AND PROMOTION',
  enter_email: 'Enter Your Email',
  subscribe: 'Subscribe',
  copyright: '© 2024  Brand  All Rights Reserved.',
  popupMenuTitle: 'MENU',
  addToCart: 'Add to Cart'
}

export const SECTIONS = [
  {
    str1: '30% OFF',
    str2: 'FOR WOMEN',
    classSuffix: 'women',
    path: '/catalog'
  },
  {
    str1: 'HOT DEAL',
    str2: 'FOR MEN',
    classSuffix: 'men',
    path: '/catalog'
  },
  {
    str1: 'NEW ARRIVALS',
    str2: 'FOR KIDS',
    classSuffix: 'kids',
    path: '/catalog'
  },
  {
    str1: 'LUXIROUS & TRENDY',
    str2: 'ACCESORIES',
    classSuffix: 'accesories',
    path: '/catalog'
  }
]

export const FEATURED_ITEMS = [
  {
    id: 1,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/1.jpg',
    color: 'blue',
    size: 'M'
  },
  {
    id: 2,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/2.jpg',
    color: 'blue',
    size: 'M'
  },
  {
    id: 3,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/3.jpg',
    color: 'blue',
    size: 'M'
  },
  {
    id: 4,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/4.jpg',
    color: 'blue',
    size: 'M'
  },
  {
    id: 5,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/5.jpg',
    color: 'blue',
    size: 'M'
  },
  {
    id: 6,
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/featured/6.jpg',
    color: 'blue',
    size: 'M'
  }
]

export const PRODUCTS = [
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/1.png'
  },
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/2.png'
  },
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/3.png'
  },
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/4.png'
  },
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/5.png'
  },
  {
    title: 'ELLERY X M\'O CAPSULE',
    desc: 'Known for her sculptural takes on traditional tailoring, Australian arbiter of cool Kym Ellery teams up with Moda Operandi.',
    price: '$52.00',
    img: 'img/products/6.png'
  }
]

export const CART = [
  {
    title: 'MANGO  PEOPLE T-SHIRT',
    price: '$300',
    color: 'Red',
    size: 'XL',
    quantity: 2,
    img: 'img/cart-image-1.jpg'
  },
  {
    title: 'MANGO  PEOPLE T-SHIRT',
    price: '$300',
    color: 'Red',
    size: 'XL',
    quantity: 2,
    img: 'img/cart-image-2.jpg'
  }
]

export const CAPABILITIES = {
  freeDelivery: {
    title: 'Free Delivery',
    subtitle: 'Worldwide delivery on all. Authorit tively morph next-generation innov tion with extensive models.'
  },
  salesDiscounts: {
    title: 'Sales & discounts',
    subtitle: 'Worldwide delivery on all. Authorit tively morph next-generation innov tion with extensive models.'
  },
  qualityAssurance: {
    title: 'Quality assurance',
    subtitle: 'Worldwide delivery on all. Authorit tively morph next-generation innov tion with extensive models.'
  }
}

export const POPUP_MENU = [
  {
    title: 'MAN',
    path: '/catalog',
    submenu: [
      {
        title: 'Accessories',
        path: '/catalog'
      },
      {
        title: 'Bags',
        path: '/catalog'
      },
      {
        title: 'Denim',
        path: '/catalog'
      },
      {
        title: 'T-Shirts',
        path: '/catalog'
      }
    ]
  },
  {
    title: 'WOMAN',
    path: '/catalog',
    submenu: [
      {
        title: 'Accessories',
        path: '/catalog'
      },
      {
        title: 'Jackets & Coats',
        path: '/catalog'
      },
      {
        title: 'Polos',
        path: '/catalog'
      },
      {
        title: 'T-Shirts',
        path: '/catalog'
      },
      {
        title: 'Shirts',
        path: '/catalog'
      }
    ]
  },
  {
    title: 'KIDS',
    path: '/catalog',
    submenu: [
      {
        title: 'Accessories',
        path: '/catalog'
      },
      {
        title: 'Jackets & Coats',
        path: '/catalog'
      },
      {
        title: 'Polos',
        path: '/catalog'
      },
      {
        title: 'T-Shirts',
        path: '/catalog'
      },
      {
        title: 'Shirts',
        path: '/catalog'
      },
      {
        title: 'Bags',
        path: '/catalog'
      }
    ]
  }
]
